import React, { useEffect, useState, Children } from 'react';
import { motion } from 'framer-motion';
import { ProductCard } from './ProductCard';
const products = [{
  image: 'https://cdn.magicpatterns.com/uploads/xwZSAM1Cgr8efPGFeRqg2b/20260305_0224_Image_Generation_remix_01kjy78j2bf57vhpmc5xfvtyz1.png',
  title: 'Mini Amigurumis: +50 Llaveros en Crochet',
  description: 'Colección de mini amigurumis perfectos para llaveros. Diseños adorables y rápidos de tejer.',
  price: '$6.99',
  comparePrice: '$14.99',
  href: 'https://kreanacrochet.com/products/llaveros'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/gN1Rb26PJSjjSLVvKKWfKN/20260305_0014_Image_Generation_simple_compose_01kjxzsbhqe9xb2tm4g92cghyf.png',
  title: 'Amigurumis Religiosos para Pascuas',
  description: 'Colección de patrones especiales ideales para Pascuas y regalos con significado espiritual.',
  price: '$9.99',
  comparePrice: '$18.99',
  href: 'https://kreanacrochet.com/products/religiosos'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/4o39UGqaQA1Vdc3tkbHTPJ/hf_20260314_132813_e792c091-55d7-40a8-bfff-a2c5594dca13.png',
  title: 'Cómo Atraer Clientes y Vender en Redes Sociales',
  description: 'Aprende a vender tus amigurumis en redes sociales. Guía paso a paso para atraer clientes y generar ventas.',
  price: '$9.99',
  comparePrice: '$22.99',
  href: 'https://kreanacrochet.com/products/vendeenredes'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/6sDphBuZjtc2SeMWDkJMrZ/20260219_1454_Image_Generation_simple_compose_01khvghz2zf3sbnhcd4zeaqh99.png',
  title: 'Mega Colección Sweaters & Cardigans Crochet (+250 Diseños)',
  description: 'Más de 250 diseños de sweaters, cardigans y sacos al crochet para crear prendas con estilo.',
  price: '$16.99',
  comparePrice: '$33.99',
  href: 'https://kreanacrochet.com/products/sweterscrochet'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/2yNyGZ8BT7sPkbqBFSNWqb/20260131_1754_Image-Generation_remix_01kgax99h5ekgvmarvah5gwkzp.webp',
  title: 'Curso de Bolsos Boutique al Crochet',
  description: 'Aprende a tejer tu primer bolso boutique en menos de 24 hs. Incluye patrones exclusivos y guía de materiales.',
  price: '$19.99',
  comparePrice: '$39.99',
  href: 'https://kreanacrochet.com/products/crochet'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    y: 20,
    opacity: 0
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.5
    }
  }
};
export function UpsellCatalog() {
  const [timeLeft, setTimeLeft] = useState(600);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const timeDisplay = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <section className="py-16 px-4 bg-[#1C1008]" data-id="element-54">
      <div className="max-w-6xl mx-auto" data-id="element-55">
        {/* FOMO Header — NO timer here */}
        <motion.div initial={{
        y: 20,
        opacity: 0
      }} whileInView={{
        y: 0,
        opacity: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-56">
          <div className="inline-flex items-center gap-2 bg-[#C17F3E]/10 text-[#C17F3E] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#C17F3E]/20" data-id="element-57">
            ⏳ Oferta exclusiva para clientes — solo visible en esta pantalla
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 font-heading leading-tight" data-id="element-58">
            Ya tienes tu colección. Ahora amplía tu catálogo a precios que no
            volverás a ver.
          </h2>
          <p className="text-[#C17F3E] text-lg md:text-xl max-w-3xl mx-auto font-medium" data-id="element-59">
            💛 Con tu compra de hoy{' '}
            <span className="text-white font-bold underline decoration-[#C17F3E] underline-offset-4" data-id="element-60">
              activaste acceso exclusivo a precios de cliente.
            </span>{' '}
            Cada producto que agregues en esta página entra con descuento
            especial —{' '}
            <span className="text-white font-bold underline decoration-[#C17F3E] underline-offset-4" data-id="element-61">
              solo disponible ahora.
            </span>
          </p>
        </motion.div>

        {/* Product Grid */}
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-62">
          {products.map((product, index) => <motion.div key={index} variants={itemVariants} data-id="element-63">
              <ProductCard image={product.image} title={product.title} description={product.description} price={product.price} comparePrice={product.comparePrice} href={product.href} data-id="element-64" />
            </motion.div>)}
        </motion.div>

        {/* Warning + Timer — ONLY here, after products */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-65">
          <p className="text-[#E85D04] font-semibold text-base" data-id="element-66">
            ⚠️ Oferta válida solo en esta pantalla — una vez que salgas no
            estará disponible más tarde.
          </p>
          <div className="bg-[#E85D04]/10 border border-[#E85D04]/30 rounded-lg px-6 py-3 mt-3 inline-block" data-id="element-67">
            <span className="text-[#E85D04] text-sm font-medium" data-id="element-68">
              Tu oferta expira en:{' '}
            </span>
            <span className="text-white font-bold text-2xl font-mono tracking-wider" data-id="element-69">
              {timeDisplay}
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}